import { openLocation } from '@/utils'
export default {
    data() {
        return {
            articleData: {},
            contentId: null,
            isSubscribe: 1,
            artType: '',
            signCount: 0,
            activityOther: [],
            toolObj: {
                comments: 0,
                isCollect: false,
                isUp: false,
                ups: 0
            },
            activityStatus: {
                1: '立即预约',
                2: '直接前往',
                3: '报名已满',
                4: '已结束'
            },
            articleFinish: false,
            isAllow: false,
            isAutoCpt: true,
            playUrl: '',
            activityIndex: 0,
            activityMenu: [{
                label: '活动详情',
                value: 1
            }]
        }
    },
    computed: {
        videos_() {
            return (this.articleData.attrs && this.articleData.attrs.videos) || [];
        },
        video_() {
            if(this.articleData.attrs && this.articleData.attrs.video){
                return [this.articleData.attrs.video]
            }
            return []
        },
    },
    props: {
        mode: {
            type: String,
            default: 'normal'
        },
        value: {
            type: Object,
            default: () => { }
        },
        showRecmd: {
            type: Boolean,
            default: true
        },
        showTools: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        value: {
            handler(val) {
                if (!val || !val.id) return;
                this.contentId = val.id;
                this.articleData = val;
            },
            deep: true,
            immediate: true
        },
        $route: {
            handler(val) {
                this.articleFinish = false;
                this.initCpt();
            },
            deep: true
        }
    },
    created() {
        this.initCpt();
    },
    methods: {
        changeActivityIndex(index) {
            this.activityIndex = index;
        },
        playMovie({ url }) {
            this.playUrl = url;
            this.$refs.playMovie.show();
        },
        initCpt: function () {
            let query = this.$route.params;
            this.contentId = query.contentId;
            this.artType = query.type;
            //获取路由地址 name
            let path = this.$route.path;
            //path 包含 activity
            if (path.includes('activity')) {
                this.artType = 'activity';
            }
            if (!(this.contentId && this.isAutoCpt)) return;
            this.getResourceDetail();
            this.contentInteractiveInfo();
            this.isAllowComment();
            this.getSignCount();
            this.getActivityOther();
        },
        async getResourceDetail() {
            if (this.articleFinish) return;
            this.articleFinish = false;
            let res = await this.$http(this.artType === 'activity' ? 'activityDetail' : 'resourceDetail', this.contentId)
            if (res.code === 1) {
                this.articleData = res.data || {};
                if(this.articleData.attrs && typeof this.articleData.attrs.isSubscribe !== 'undefined'){
                    var isSubscribeData = this.articleData.attrs.isSubscribe;
                    var parse = JSON.parse(isSubscribeData);
                    if (parse.value){
                        this.isSubscribe =  parse.value;
                    }
                    // 如果结束时间小于当前时间,则不显示报名按钮
                    if (new Date(this.articleData.attrs.endDate.replace(/-/g, '/')).getTime() <= new Date().getTime()) {
                        this.isSubscribe = 2;
                    }
                }
            }
            this.articleFinish = true;
        },
        showModal(modal, status = 1) {
            if (status > 2) return this.$toast('活动' + this.activityStatus[status])
            this.$refs[modal].show();
        },
        comment(type) {
            this.$Router.push({
                name: 'comment',
                params: {
                    contentId: this.contentId,
                    type: type || ''
                }
            })
        },
        async collection(contentId, isCollect) {
            isCollect = isCollect === undefined ? this.toolObj.isCollect : isCollect;
            contentId = contentId === undefined ? this.contentId : contentId
            let res = await this.$http(isCollect ? 'collectionCancel' : 'collection', {
                contentId: contentId
            })
            if (this.isAutoCpt) {
                res.code === 1 && this.contentInteractiveInfo();
            } else {
                return res.code === 1 ? true : false;
            }
        },
        async resourceUp(contentId, isUp) {
            isUp = isUp === undefined ? this.toolObj.isUp : isUp;
            contentId = contentId === undefined ? this.contentId : contentId
            let res = await this.$http(isUp ? 'resourceCancelUp' : 'resourceUp', {
                contentId: contentId
            });
            if (this.isAutoCpt) {
                res.code === 1 && this.contentInteractiveInfo();
            } else {
                return res.code === 1 ? true : false;
            }
        },
        async isAllowComment() {
            if (this.artType === 'map') return;
            let res = await this.$http('isAllowComment');
            this.isAllow = res.data;
            if (res.data) this.activityMenu.push({
                label: '讨论区',
                value: 2
            })
        },
        async contentInteractiveInfo() {
            let res = await this.$http('contentInteractiveInfo', {
                contentId: this.contentId
            });
            this.toolObj = res.data || {}
        },
        openLocation() {
            openLocation(this.articleData.attrs.latitude, this.articleData.attrs.longitude, this.articleData.title, this.articleData.attrs.address);
        },
        async getSignCount() {
            let res2 = await this.$http('getActivitySignCount',this.contentId);
            this.signCount = isNaN(res2.data) ? 0 : res2.data ;
        },
        async getActivityOther() {
            let params = {
                channelPaths: 'zyxm',
                activityStatus: 1,
                size: 10,
                page: 1
            }
            let res = await this.$http('activityPage', params);
            this.activityOther = res.data.content || [];
        }
    }
}
